import React from 'react';
import SectionTitle from '../../../components/section-title';
import { Link } from 'gatsby';
import CustomImage from '../../../components/custom-image';
import ScrollPositionAnimation from '../../../components/scrollpositionanimation';
import ContentSlider from '../../../components/content-slider';

const HighlightsOfTheYear = () => {
  const slider = {
    slides: [
      <div>
        <CustomImage
          className="custom-image"
          imageName="highlight-of-year.png"
          alt="Highlights Of TheYear"
          maxWidth="688"
        />
      </div>,
      <div>
        <CustomImage
          className="custom-image"
          imageName="highlight-of-year1.png"
          alt="Highlights Of TheYear"
          maxWidth="688"
        />
      </div>,
    ],
    mobileslider: [
      <div>
        <CustomImage
          className="custom-image"
          imageName="group-report-char-one.png"
          alt="Highlights Of TheYear Revenue"
          maxWidth="688"
        />
      </div>,
      <div>
        <CustomImage
          className="custom-image"
          imageName="group-report-char-two.png"
          alt="Highlights Of TheYear EBITDA"
          maxWidth="688"
        />
      </div>,
      <div>
        <CustomImage
          className="custom-image"
          imageName="group-report-char-three.png"
          alt="Highlights Of TheYear Return On Capital"
          maxWidth="688"
        />
      </div>,
      <div>
        <CustomImage
          className="custom-image"
          imageName="group-report-char-four.png"
          alt="Highlights Of TheYear Dividend"
          maxWidth="688"
        />
      </div>,
    ],
  };
  return (
    <div className="highlight-of-the-year">
      <div className="container">
        <div className="container-inner">
          <ScrollPositionAnimation targetElement1="anim-10" targetElement2="anim-11">
            <div className="content-row">
              <div className="column-30">
                <div className="left-to-right anim-10">
                  <div className="left-content">
                    <SectionTitle lighttext="Group " boldtext="Highlights" isSectionH1={false}></SectionTitle>
                    <div className="button-text">
                      <Link to="/overview/vedanta-at-a-glance/group-highlights" className="trans-btn white btn-sm">
                        See All Highlights
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
              <div className="column-70">
                <div className="bottom-to-top anim-11">
                  <div className="right-content">
                    <div className="desktop-img">
                      <div className="image-box">
                        <ContentSlider
                          data={slider.slides}
                          customClass="blue-dots-slider"
                          slidesToShow={1}
                          slidesToScroll={1}
                          prevBtn="blue-prev-btn"
                          nextBtn="blue-next-btn"
                          dots={true}
                        />
                      </div>
                    </div>
                    <div className="mobile-img">
                      <div className="image-box">
                        <ContentSlider
                          data={slider.mobileslider}
                          customClass="blue-dots-slider"
                          slidesToShow={1}
                          slidesToScroll={1}
                          dots={true}
                        />
                      </div>
                      <div className="button-text">
                        <Link to="/overview/vedanta-at-a-glance/group-highlights" className="trans-btn white">
                          See All Highlights
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ScrollPositionAnimation>
        </div>
      </div>
    </div>
  );
};

export default HighlightsOfTheYear;
